export default __webpack_public_path__ + "static/media/plus-circle-fill.d6d4031c.svg";